import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {PackageService} from '../../shared/services/package.service';
import {StockistService} from '../../shared/services/stockist.service';
import {ProductService} from '../../shared/services/product.service';
import {UserService} from '../../shared/services/user.service';
import {PackageOrderService} from '../../shared/services/package-order.service';
import {AlertService} from '../../shared/services/alert.service';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Router} from '@angular/router';
import {round} from 'lodash';
import {RazorpayService} from '../../shared/services/razorpay.service';

@Component({
    selector: 'app-package',
    templateUrl: './package.component.html',
    styleUrls: ['./package.component.scss']
})
export class PackageComponent implements OnInit {
    searchForm: FormGroup;
    packages: any = [];
    stockists: any = [];
    stockistPackages: any = [];
    submitting: any = false;
    submitted_loader: any = false;
    userData: any;
    selectedPackage: any;
    selectedPaymentMethod: string = 'wallet';

    constructor(private fb: FormBuilder,
                private packageService: PackageService,
                private stockistService: StockistService,
                private userService: UserService,
                private productService: ProductService,
                private packgeOrderservice: PackageOrderService,
                private alertService: AlertService,
                private router: Router,
                public modalService: NgbModal,
                private razorpayService: RazorpayService) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    refresh() {
        this.searchForm = this.fb.group({
            'name': [''],
            'package_amount': [''],
            'package_value': [''],
            'capping_amount': ['']
        });
        this.getUserDetail();
    }

    getUserDetail() {
        this.userService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                this.get();
            }
        });
    }

    get(params: any = {}) {
        this.submitting = true;
        this.packages = [];
        this.packageService.get(params).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.packages = data['data'];
                if (this.userData && this.userData.package && this.userData.package.package_amount) {
                    this.packages.forEach(userPackage => {
                        if (userPackage) {
                            userPackage['user_package_amount'] = parseInt(userPackage.package_amount) - parseInt(this.userData.package.package_amount);
                        }
                    });
                } else {
                    this.packages.forEach(userPackage => {
                        if (userPackage) {
                            userPackage['user_package_amount'] = parseInt(userPackage.package_amount);
                        }
                    });
                }
            } else {
                this.packages = [];
            }
            this.getStockists();
            this.submitting = false;
        }, error => {
            this.submitting = false;
        });
    }

    getStockists() {
        this.stockistService.get({'page': -1}).subscribe(data => {
            if (data && data['data'].length > 0) {
                this.stockists = data['data'];
            } else {
                this.stockists = [];
            }
        });
    }

    getStockistPackage(event, userPackage, amount) {
        this.productService.getStockistProduct(event.target.value, {'page': -1, 'type': 'PACKAGE'}).subscribe(data => {
            if (data && data['data'].length > 0) {
                const userPackages = [];
                // userPackage['stockist_packages'] = data['data'];
                data['data'].forEach(dd => {
                    if (dd.mrp == amount) {
                        userPackages.push(dd);
                    }
                });
                userPackage['stockist_packages'] = userPackages;
                if (this.stockists && this.stockists.length > 0) {
                    this.stockists.forEach(stockist => {
                        if (stockist['unique_id'] === event.target.value) {
                            userPackage['stockist_id'] = stockist.id;
                        }
                    });
                }
            }
        });
    }

    chooseStockistPackage(event, userPackage) {
        userPackage['product_id'] = parseInt(event.target.value);
    }

    upgradePackageModal(content, userPackage) {
        if (!this.userData['address'] || !this.userData['pin_code'] || !this.userData['city']) {
            this.router.navigateByUrl('my-profile');
            this.alertService.showErrors('Please Update Your Address');
            return;
        }
        if (!userPackage || !userPackage.stockist_id) {
            this.alertService.showErrors('Please choose stockist to proceed');
            return;
        }
        if (!userPackage || !userPackage.product_id) {
            this.alertService.showErrors('Please choose package to proceed');
            return;
        }
        this.modalService.open(content, {'size': 'sm'});
        this.selectedPackage = userPackage;
    }

    upgradeFromWallet() {
        this.submitting = true;
        this.submitted_loader = true;
        if (this.submitting) {
            if (!this.selectedPackage || !this.selectedPackage.stockist_id) {
                this.alertService.showErrors('Please choose stockist to proceed');
                return;
            }
            if (!this.selectedPackage || !this.selectedPackage.product_id) {
                this.alertService.showErrors('Please choose package to proceed');
                return;
            }
            const params = {
                'product_id': this.selectedPackage.product_id,
                'stockist_id': this.selectedPackage.stockist_id,
                'package_id': this.selectedPackage.id,
            };
            this.packgeOrderservice.add(params).subscribe(data => {
                this.submitting = false;
                this.submitted_loader = false;
                this.modalService.dismissAll('');
                setTimeout(this.reloadWindow, 1000);
            }, error => {
                this.submitting = false;
                this.submitted_loader = false;
                if (error && error['error'] && error['error']['error']) {
                    this.alertService.showErrors(error['error']['error']);
                    return;
                }
            });
        }
    }

    upgradeFromOnline(packageAmount) {
        this.submitting = true;
        this.submitted_loader = true;
        if (this.submitting) {
            if (!this.selectedPackage || !this.selectedPackage.stockist_id) {
                this.alertService.showErrors('Please choose stockist to proceed');
                return;
            }
            if (!this.selectedPackage || !this.selectedPackage.product_id) {
                this.alertService.showErrors('Please choose package to proceed');
                return;
            }
            const orderDetails = {
                'amount': packageAmount + '00',
                'currency': 'INR',
            };
            this.razorpayService.genrateOrderId(orderDetails).subscribe(orderIdData => {
                if (orderIdData && orderIdData.id) {
                    this.modalService.dismissAll('');
                    const params = {
                        'amount': packageAmount + '00',
                        'name': this.userData.name,
                        'email': this.userData.email,
                        'contact': this.userData.contact,
                        'order_id': orderIdData.id,
                    };
                    this.razorpayService.initializePayment(params);
                    this.razorpayService.getPaymentResponseObservable().subscribe(response => {
                        if (response && response.razorpay_payment_id) {
                            const paramss = {
                                'payment_status': 'COMPLETED',
                                'amount': packageAmount,
                                'transaction_id': response.razorpay_payment_id,
                                'order_id': orderIdData.id,
                                'product_id': this.selectedPackage.product_id,
                                'stockist_id': this.selectedPackage.stockist_id,
                                'package_id': this.selectedPackage.id,
                            };
                            this.packgeOrderservice.addPackageOnline(paramss).subscribe(data => {
                                this.submitting = false;
                                this.submitted_loader = false;
                                this.modalService.dismissAll('');
                                setTimeout(this.reloadWindow, 1000);
                            }, error => {
                                this.submitting = false;
                                if (error && error['error'] && error['error']['error']) {
                                    this.alertService.showErrors(error['error']['error']);
                                    return;
                                }
                            });
                        }
                    }, error => {
                        this.submitting = false;
                        this.submitted_loader = false;
                        if (error && error['error'] && error['error']['error']) {
                            this.alertService.showErrors(error['error']['error']);
                            return;
                        }
                    });
                }
            }, error => {
                this.submitting = false;
                this.submitted_loader = false;
                if (error && error['error'] && error['error']['error']) {
                    this.alertService.showErrors(error['error']['error']);
                    return;
                }
            });
        }
    }


    reloadWindow() {
        window.location.reload();
    }
}
